import React from 'react';
import classNames from 'classnames';

import ProfileImage, {
  IMAGE_SIZES
} from '@buyside/components/presentation/ProfileImage/profileImage';
import Skeleton, {
  SKELETON_SIZES,
  SKELETON_WIDTHS
} from '@buyside/components/presentation/Skeleton/skeleton';

import { defaultUserImageUrl } from '@buyside/util/urlHelper';

import styles from './authorDisplayStyles.scss';

const AuthorDisplayLoading: React.FC = () => {
  return (
    <div className={styles.authorContainer}>
      <section className={styles.section}>
        <span className={styles.image}>
          <ProfileImage source={defaultUserImageUrl()} size={IMAGE_SIZES.SMALLER} />
        </span>
        <div className={styles.authorInfo}>
          <div>
            <div className={styles.heading}>
              <Skeleton size={SKELETON_SIZES.SMALL} width={SKELETON_WIDTHS.SMALL} />
            </div>
            <div className={styles.heading}>
              <Skeleton width={SKELETON_WIDTHS.MEDIUM} />
            </div>
          </div>
        </div>
      </section>
      <section className={classNames(styles.section, styles.employer)}>
        <div>
          <div className={styles.heading}>
            <Skeleton size={SKELETON_SIZES.SMALL} width={SKELETON_WIDTHS.SMALL} />
          </div>
          <div className={styles.heading}>
            <Skeleton width={SKELETON_WIDTHS.MEDIUM} />
          </div>
        </div>
      </section>
    </div>
  );
};

export default AuthorDisplayLoading;
